import { styled } from '@mui/system';
import { Divider as DividerMUI } from '@mui/material';
import { theme } from 'oems/theme';

export const Title = styled('h3')`
  font-weight: 700;
  font-size: 18px;
  line-height: 125%;
  color: ${theme.palette.text.dark};
  margin-bottom: 24px;
`;

export const DateRangeWrapper = styled('div')`
  margin-bottom: 24px;
`;

export const Documents = styled('div')`
  font-size: 13px;
  line-height: 150%;
  padding: 10px;
  border-radius: 6px;
  background: ${theme.palette.brand.secondary};
`;

export const Divider = styled(DividerMUI)`
  margin: 24px 0;
  background-color: ${theme.palette.border.light};
  background-image: none !important;
  opacity: 1;
`;

export const ButtonWrapper = styled('div')`
  width: 100%;

  > div {
    width: 100%;
  }

  button {
    width: 100%;
    display: flex;

    .label {
      svg {
        width: 21px;
        height: 21px;
        margin-right: 10px;
      }
    }
  }
`;
